import './app.scss';
import Routing from '../routing';
import ThemeProvider from './contexts/theme';
import Header from '../common/components/header';
import Auth from './contexts/auth';
import Toast from './contexts/toast';
import Toasts from '../common/components/toasts';
import LanguageContext from './contexts/language';

export default function App() {
    return (
        <LanguageContext.LanguageProvider>
            <Auth.AuthProvider>
                <ThemeProvider>
                    <Toast.ToastProvider>
                        <Header />
                        <Toasts />
                        <Routing />
                    </Toast.ToastProvider>
                </ThemeProvider>
            </Auth.AuthProvider>
        </LanguageContext.LanguageProvider>
    );
}
